import { useSearchParams } from 'react-router-dom'

/** Debug: `?fontSizes=1` (also `fontSize=1`, `font-size=1`) — кегль у каждого текстового блока. */
export function useResumeFontSizeDebugMode(): boolean {
  const [searchParams] = useSearchParams()
  return (
    searchParams.get('fontSizes') === '1' ||
    searchParams.get('fontSize') === '1' ||
    searchParams.get('font-size') === '1'
  )
}
